
import { stylesheet, classes } from 'typestyle'

/* Common ======================================================================================= */
import { getCurrentUser } from '../../../services/auth'

/* Hooks ======================================================================================== */
import useFetch from '../../../hooks/use-fetch'
import useLocal from '../../../hooks/use-local'

/* Components =================================================================================== */
import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text/text.component'
import { Line } from '../../../components/line'

/* Styles ======================================================================================= */
import { createMediaQuery } from '../../../components/style-class/style-class.utils'
import { p12 } from '../../../styles/styleset/padding/p12'
import { mr8 } from '../../../styles/styleset/margin/mr8'
import { GLOBAL_CONTENTS } from '../../../common/global-contents'

/* <PasswordChagne /> =========================================================================== */
Modal.add('PasswordChange', (props: any) => {
  const { self = true } = props
  const [local] = useLocal()
  const [passwordReset, $passwordReset] = useFetch(
    {},
    {
      url: `${process.env.REACT_APP_API_URL}/a/users/password-forget`,
    },
  )
  const { currentUser } = getCurrentUser()

  return (
    <Box onClick={props.handleContentClick} rounded row>
      <Box className={classes(p12)} flex>
        <Text size="md">
          {self
            ? GLOBAL_CONTENTS.changePasswordConfirmationSelf[local]
            : GLOBAL_CONTENTS.changePasswordConfirmation[local]}
        </Text>
      </Box>
      <Line />
      <Box className={classes(p12, STYLES.container)} baseline="none" spaceBetween fullWidth>
        <Box />
        <Box column>
          <Button
            className={mr8}
            onClick={Modal.pop}
            label={GLOBAL_CONTENTS.close[local]}
            baseline="background"
            size="md"
            square
          />
          {passwordReset.isLoading ? (
            <Button label="Sending ..." baseline="primary" size="md" square />
          ) : (
            <Button
              label={GLOBAL_CONTENTS.submit[local]}
              baseline="primary"
              size="md"
              square
              onClick={() => {
                $passwordReset.post({ body: { email: currentUser.email } }).then(() => {
                  Modal.pop()
                })
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
})

/* Styles ======================================================================================= */
const STYLES = stylesheet({
  container: {
    maxHeight: 420,
    overflow: 'auto',
    ...createMediaQuery['sm']({
      maxHeight: 360,
    }),
  },
})
